<template>
  <div>
    <div class="scenario_part retire-4 scenario_bgs">
      <div class="container">
        <div class="all_wrapper flex">
          <div class="scenario_dialog" key="3" >
            <h2>出國散心想多久飛一次？</h2>
            <div class="scenario_option">
              <ul>
                <li>
                  <a href="" @click.prevent="toNext('retire_5','retire_form', 12, '1個月')">
                    <div class="option_img">
                      <img src="@/assets/images/needs/banner-retire/traveling.svg" alt="">
                    </div>
                    <div class="option_text">
                      <p>1 個月</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="" @click.prevent="toNext('retire_5','retire_form', 4, '3 個月')">
                    <div class="option_img">
                      <img src="@/assets/images/needs/banner-retire/traveling.svg" alt="">
                    </div>
                    <div class="option_text">
                      <p>3 個月</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="" @click.prevent="toNext('retire_5','retire_form', 1, '半年以上')">
                    <div class="option_img">
                      <img src="@/assets/images/needs/banner-retire/traveling.svg" alt="">
                    </div>
                    <div class="option_text">
                      <p>半年以上</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ProgressBar :page="page"></ProgressBar>
    </div>


  </div>
</template>

<script>

import GA from "@/func/seo";
import ProgressBar from '@/components/common/progress_bar'

export default {
  name: "retire_4",
  components: {ProgressBar},
  data: function () {
    return {
      page: {
        page_no: 5,
        total: 6,
        isRetire: true
      }
    }
  },
  methods: {
    toNext(from, to, times, option) {
      this.$store.dispatch('retire/setAbroadTimes', times)
      let optionNo = 'option5'
      this.$store.dispatch('retire/addOption', {optionNo, option})
      store.set('retire/changeShow!', {from, to})
    },
  },
  mounted() {
    GA.pushRetireEvent(5, '出國散心想多久飛一次')
  }
}

</script>

<style scoped>
#SUN {
  animation: sunRotation 3s linear infinite;
  -moz-animation: sunRotation 3s linear infinite;
  -webkit-animation: sunRotation 3s linear infinite;
  -o-animation: sunRotation 3s linear infinite;
  transform-origin: center;
  /*改變中心點*/
  transform-box: fill-box;
  /*原地*/
}

@-webkit-keyframes sunRotation {
  from {
    -webkit-transform: rotateZ(0deg);
  }

  to {
    -webkit-transform: rotateZ(360deg);
  }
}

.scenario_dialog .scenario_option ul li {
  margin: 8px;
  background-color: #fff !important;
  border-radius: 6px !important;
  width: 33.3334%;
  border: 3px solid #fff;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  padding: 0 !important;
}

.scenario_dialog .scenario_option ul li:hover {
  border: 3px solid #000 !important;
}

@media (max-width: 767px) {
  .scenario_dialog .scenario_option ul li {
    margin: 8px 0;
    width: 100%;
  }
}
</style>
